export * from './rhombus.model';
export { createRhombus } from './rhombus.creator';
